module.exports = __webpack_public_path__ + "img/user-profile.b200131c.png";